<template lang="pug">
el-table(:data="list" size="mini" stripe border height="100%")
  el-table-column(min-width="180" label="广告名称" align="center" prop="contentName")
  el-table-column(min-width="140" label="下单时间" align="center" prop="createTime")
  el-table-column(min-width="90" label="创建人" align="center" prop="creatorName")
  el-table-column(min-width="180" label="订单编号" align="center")
    template(slot-scope="{row}")
      el-tooltip(effect="light" placement="top" popper-class="order_code_pop")
        .order_code(@click="orderDetail(row)") {{ row.orderCode }}
        .pop_content(slot="content" @click="copyOrderCode(row.orderCode)") {{ row.orderCode }}&nbsp;|&nbsp;复制
  el-table-column(min-width="90" label="数据存储(天)" align="center" prop="pictureStorageDays")
  el-table-column(min-width="180" label="预估投放日期" align="center")
    template(slot-scope="{row: { startDate, endDate, dateNum, isCpmL, stopTypes, orderType }}")
      div(v-if="isCpmL") {{ startDate }}
      div(v-else) {{ startDate }} 至 {{ endDate }}
      div(v-if="isCpmL") (预计{{ `${ dateNum }天` }})
      //- stopTypes [2] 需排除CPL订单
      div(v-else-if="stopTypes && stopTypes.indexOf(2) > -1 && orderType !== 6005") (共{{ `${ dateNum - 2 }+2天` }})
      div(v-else) (共{{ `${ dateNum }天` }})
  //- el-table-column(min-width="180" label="实际投放日期" align="center")
  //-   template(slot-scope="{row: { validStartDate, validEndDate, dateList, orderStatus }}")
  //-     div(v-if="orderStatus != 4 || !validStartDate || !validEndDate") --
  //-     template(v-else)
  //-       div {{ validStartDate }} 至 {{ validEndDate }}
  //-       div (共{{ `${ dateList && dateList.length || 0 }天` }})
  el-table-column(min-width="130" label="投放时段" align="center")
    template(slot-scope="{row: { timeSlots, timeSlotsNum }}")
      div {{ `${ (timeSlots || '').split(',').length }时段(播放${ timeSlotsNum }次)` }}
  el-table-column(min-width="120" label="价格" align="center" prop="amount")
    template(slot-scope="{row}")
      span {{row.amount.toFixed(2)}}元
  el-table-column(min-width="220" label="订单组别" align="center" prop="amount")
    template(slot-scope="{row}")
      div(v-if="row.orderGroupCode")
        div {{formatTagName(row.orderGroupCode).name}}
        el-tag(size="small" v-if="formatTagName(row.orderGroupCode).tag") {{formatTagName(row.orderGroupCode).tag}}
      div(v-else)
        div {{ row.startDate }} 至 {{ row.endDate }}
  el-table-column(min-width="100" label="订单状态" align="center" prop="orderStatusName")
  el-table-column(min-width="150" label="合同编码" align="center" prop="contractNo")
  el-table-column(min-width="80" label="屏幕位置" align="center")
    template(slot-scope="{row}")
      div(v-for="(ele, i) in row.showScreenTypeName") {{ele}}
  el-table-column(min-width="100" label="类型" align="center")
    template(slot-scope="{row}")
      div(v-for="(ele, i) in row.screenAreaName") {{ele}}
  el-table-column(min-width="110" label="广告类型" align="center" prop="")
    template(slot-scope="{row: {advContentDto: dto}}") {{ dto ? adType2Name.get(dto.advertType) : '' }}
  el-table-column(min-width="120" label="操作" align="center")
    template(slot-scope="{row}")
      .ol-buton(@click="orderDetail(row)") 查看订单
      template(v-if="row.orderStatus == 2 || row.orderStatus == 3")
        //- .ol-buton.red(v-if="!row.execStatus || row.execStatus == 0" @click="setCurrentDetail(row, 'showUpload')") 上传素材
        //- .ol-buton.red(v-else @click="setCurrentDetail(row, 'showUpload')") 更换素材
        .ol-buton.red(@click="setCurrentDetail(row, 'showUpload')") {{ opTypeStr(row) }}{{ typeStr(row) }}

      template(v-if="!isActionUser")
        .ol-buton(v-if="row.orderStatus == 3 || row.orderStatus == 4" @click="watchDetail(row)") 投放详情
        .ol-buton(
          v-if="showMonitBtn(row)"
          :class="{ dis: row.noMonit }"
          :title="row.noMonit ? '已过60天服务期！' : ''"
          @click="showMonitService(row)"
        ) 监播服务

        //- wifi广告隐藏[码上服务]
        .ol-buton(
          v-if="!limitUser && (row.orderStatus == 2 || row.orderStatus == 3 || row.orderStatus == 4) && row.orderType !== 6007"
          @click="codeService(row)"
        ) 码上服务
        template(v-if="row.orderStatus == 0")
          .ol-buton(@click="cancelOrder(row)") 取消订单
          .ol-buton.red(@click="goUrl('/orderPay', { id: row.guid, freeMark: row.payWay })") 立即支付

        template(v-if="row.orderStatus == 4")
          .ol-buton.disabled(v-if="row.appralId") 已评价
          .ol-buton.red(v-else @click="giveMark(row)") 我要评价
</template>

<script>
import { uniCopy } from "@/utils/functions"

export default {
  name: 'ListTable',
  props: {
    data: Array,
    default() {
      return []
    },
    orderTagList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {
    list() {
      return (this.data || []).map((el) => {
        let { stopTypes, orderType } = el
        el.isCpmL = orderType == 6002 && stopTypes && stopTypes.indexOf(2) > -1
        return el
      })
    },
    isActionUser() {
      // 线上环境 演示用户 相关按钮权限控制
      let userInfo = this.$store.state.customer.userInfo
      return process.env.NODE_ENV == 'production' && userInfo && userInfo.id == 2000831
    },
    limitUser() {
      // 限制性用户(无溯源查看权限)
      const info = this.$store.state.customer.userInfo
      return [2003128].indexOf(info.id) > -1
    },
    opTypeStr() {
      return (row) => {
        return row.execStatus ? '更换' : '上传'
      }
    },
    typeStr() {
      return (row) => {
        return row.screenArea && row.screenArea == 3 ? 'URL' : '素材'
      }
    },
    isWifi() {
      return (item) => item.screenArea == 3
    },
    isH5RealTime() {
      return (item) => item.screenArea == 4
    },
    isSmallSn() {
      return (item) => item.screenArea == 1
    },
    playType() {
      return this.$store.state.common.CONTENTPLAYTYPE
    },
    adType2Name() {
      return new Map(this.playType.map((e) => [Number(e.value), e.label]))
    }
  },
  created() {
    if (!this.playType.length) this.$store.dispatch('getContentPlayType')
  },
  methods: {
    formatTagName(code) {
      const obj = this.orderTagList.find(item => item.code === code)
      return obj ? {
        name: `${obj.startDate }~ ${obj.endDate}`,
        tag:obj.tag
      } : {
          name: '',
          tag:''
      }
    },
    showMonitBtn({ orderStatus, screenArea, execStatus, screenAreaCode }) {
      let noType = [3, 4]
      return execStatus == 2 && (orderStatus == 2 || orderStatus == 3 || orderStatus == 4) && noType.indexOf(screenArea) < 0 && screenAreaCode != 50

      // 监播服务按钮展示
      // execStatus 2 素材审核成功
      // orderStatus 2 准备中 3 进行中 4 已完成
      // screenArea 3:WiFi广告 4:实时广告 50:RTB限量
      // screenAreaCode 50:RTB限量
    },
    codeService(row) {
      this.$emit('codeService', row)
    },
    async copyOrderCode(str) {
      const res = await uniCopy(str)
      if (res) this.messageTip('复制成功', 1)
    },
    orderDetail(row) {
      this.$emit('orderDetail', row)
    },
    async watchDetail(row) { // 投放详情click
      this.$emit('watchDetail', row)
    },
    showMonitService(row) {
      this.$emit('showMonitService', row)
    },
    async setCurrentDetail(row, type) {
      this.$emit('setCurrentDetail', row, type)
    },
    cancelOrder(row) {
      this.$emit('cancelOrder', row)
    },
    giveMark(row) {
      this.$emit('giveMark', row)
    }
  }
}
</script>

<style lang="scss" scoped>
  .order_code {
    cursor: pointer;
    color: #6296FF;
  }
</style>
<style lang="sass">
.order_code_pop.el-tooltip__popper
  border-color: #6296FF
  color: #6296FF
  padding: 5px 10px
  .pop_content
    line-height: 20px
.order_code_pop.is-light[x-placement^=top] .popper__arrow
  border-top-color: #6296FF
.ol-buton
  color: #282729
  font-size: 12px
  font-weight: 500
  line-height: 1.2
  margin-bottom: 10px
  cursor: pointer
  &:last-child
    margin-bottom: 0
  &.red
    color: #ff3973
  &.dis
    color: #999
    cursor: not-allowed

::v-deep .el-table
  border-top: none
  height: 100%
  .el-table__header
    background: #F1F1F1
    .cell
      border-right: 1px solid #D4D4D4
      color: #282729
      height: 24px
      line-height: 24px
    .is-leaf
      border-right: none
      background: #F1F1F1
  .el-table__row
    td
      padding: 10px 0
</style>
